import { ChangeEvent, MutableRefObject } from 'react';
import styled from 'styled-components';

interface TelInputProps {
  inputValue: string | undefined;
  placeholder: string;
  onChange: (newValue: string | undefined) => void;
  inputRef: MutableRefObject<HTMLInputElement | null>;
}

export const TelInput = ({ inputValue, placeholder, onChange, inputRef }: TelInputProps) => {
  return (
    <Input
      type={'tel'}
      maxLength={11}
      placeholder={placeholder}
      value={inputValue}
      ref={inputRef}
      onChange={(event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.value) {
          const newValue = event.target.value;
          onChange(newValue);
        } else {
          onChange(undefined);
        }
      }}
    />
  );
};

const Input = styled.input`
  width: 100%;
  height: 40px;
  min-height: 40px;

  gap: 8px;

  padding: 10px 16px;

  border-radius: var(--radius-medium, 8px);
  border: 1px solid var(--Light-Scheme-Monochrome-grey20, #e4e4ed);
  background: var(--Light-Scheme-Monochrome-white, #fff);

  text-align: left;

  &::placeholder {
    color: var(--Light-Scheme-Monochrome-grey70, #a7a9b6);

    /* Body/Medium/m-regular */
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 21px */

    text-align: left;
  }
`;
